/** Высота поля поиска — §28: ~46. Точного токена нет ($control-height-s — 44, ближайший). */
export const SEARCH_INPUT_HEIGHT = '46px'

export const SEARCH_INPUT_ICON_SIZE = 16
export const SEARCH_INPUT_CLEAR_ICON_SIZE = 14

/** Дебаунс onSearch — город вводится по буквам, ищем не на каждое нажатие. */
export const SEARCH_INPUT_DEBOUNCE_MS = 300
